<template>
  <div>
   <tabs id="tabs">
     <tab name="Inbox" :selected="true">
       <div class="row">
         <div class="col-xs-12 col-sm-12 col-lg-12 mt-2">
           <DemoLoader inbox="inbox"></DemoLoader>
         </div>
       </div>
     </tab>
     <tab name="Approved">
       <div class="row">
         <div class="col-xs-12 col-sm-12 col-lg-12 mt-2">
           <DemoLoader inbox="approved"></DemoLoader>
         </div>
       </div>
     </tab>
     <tab name="Declined">
       <div class="row">
         <div class="col-xs-12 col-sm-12 col-lg-12 mt-2">
           <DemoLoader inbox="declined"></DemoLoader>
         </div>
       </div>
     </tab>
   
   </tabs>
  </div>
</template>

<script>
import Tabs from "../components/Tabs";
import Tab from "../components/Tab";
import DemoLoader from "../components/DemoLoader";

export default {
  name: "Demos",
  components: {
    Tabs,
    Tab,
    DemoLoader,
  },
  mounted() {
    this.$globals.getContests();
    this.$globals.getDemos();
    
      /*if(localStorage.newAccount){
         const introJS = require("intro.js");
         introJS().setOptions({
           steps: [{
             intro: "This is your demo manager. Here you find all the incoming demo's from your contests."
           },{
              element: document.querySelector('#tabs'),
              intro: "With these tabs you can select an inbox. Your demo's are grouped by new, declined and approved. "
            }]
         }).start().oncomplete(function() {
          localStorage.newAccount = false;
          window.location.href = '/';
       }); 
    }*/
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      demos: null,
    };
  },
  methods: {},
};
</script>
